export const checkPassword = (password: string) => {
  if (password.length < 8) {
    return '密碼長度需大於八位';
  } else if (!password.match(/^(?=.*[a-zA-Z])(?=.*\d)/)) {
    return '密碼需包含英文和數字';
  } else {
    return '';
  }
};
